export const v3ShoppableOneUpCardCarouselModuleData = {
  "_key": "d2009db7fe62",
  "_type": "shoppable1UpCarousel",
  "module": "v3shoppable1UpCarousel",
  "moduleColor": "Primary",
  "items": Array.from({length: 10}, (_, index) => ({
    "title": `The Londoner`,
    "location": `London, U.K.`,
    "description": `Lorem ipsum dolor sit amet consectetur. Vel fermentum phasellus semper eu nulla venenatis viverra variusisque.Lorem ipsum dolor sit amet consectetur.`,
    "rating": (8.5 + index / 10).toFixed(1),
    "ratingComment": index % 2 === 0 ? "Excellent" : "Good",
    "numberOfReviews":130,
    "price": `£${251}`,
    "priceType": "per night",
    "date": `26 Apr - 27 Apr`,
    "imageAspectRatio": "CPDS_4x3",
    "cta": {
      "_key": null,
      "ctaText": "Book Now",
      "ctaUrl": null,
      "openUrlInNewTab": false
    },
    "image": {
      "asset": {
        "url": `https://via.placeholder.com/400x300?text=Card+${index + 1}`
      }
    }
  }))
};

export const v3TestimonialCarouselModuleData = {
  "_key": "d2009db7fe62",
  "_type": "shoppable1UpCarousel",
  "module": "v3shoppable1UpCarousel",
  "moduleColor": "Primary",
  "title": "Testimonial Carousel",
  "eyebrow": "Testimonial",
  "imageAspectRatio": "CPDS_1x1",
  "items": Array.from({length: 10}, (_, index) => ({
    "quoteEyebrow": `Testimonial item ${index + 1}`,
    "quoteRaw": `Lorem ipsum dolor sit amet consectetur. Vel fermentum phasellus semper eu nulla venenatis viverra variusisque.Lorem ipsum dolor sit amet consectetur.`,
    "authorName": `Testimonial Author ${index + 1}`,
    "subHead": "Lorem ipsum dolor sit amet consectetur. Vel fermentum phasellus semper eu nulla venenatis viverra variusisque.Lorem ipsum dolor sit amet",
    "ctaText": "Read More",
    "ctaUrl": "https://www.example.com",
    "testimonialImage": {
      "asset": {
        "url": `https://via.placeholder.com/400x300?text=Card+${index + 1}`
      }
    }
  }))
};

export const v3ShoppableOneUpCardCarouselModuleData2 = {
  "_key": "d2009db7fe62",
  "_type": "shoppable1UpCarousel",
  "module": "v3shoppable1UpCarousel",
  "moduleColor": "Tertiary",
  "items": Array.from({length: 10}, (_, index) => ({
    "title": `Card ${index + 1} Title`,
    "location": `Location ${index + 1}`,
    "description": `Lorem ipsum dolor sit amet consectetur. Vel fermentum phasellus semper eu nulla venenatis viverra variusisque.Lorem ipsum dolor sit amet consectetur.`,
    "rating": (8.5 + index / 10).toFixed(1),
    "ratingComment": index % 2 === 0 ? "Excellent" : "Good",
    "numberOfReviews": 120 + index * 5,
    "price": `£${250 + index * 10}`,
    "priceType": "per night",
    "date": `26 Apr - 27 Apr`,
    "imageAspectRatio": "CPDS_1x1",
    "cta": {
      "_key": null,
      "ctaText": "Book Now",
      "ctaUrl": null,
      "openUrlInNewTab": false
    },
    "image": {
      "asset": {
        "url": `https://via.placeholder.com/300x300?text=Card+${index + 1}`
      }
    }
  }))
};

export const v3ShoppableOneUpCardCarouselModuleData3 = {
  "_key": "d2009db7fe62",
  "_type": "shoppable1UpCarousel",
  "module": "v3shoppable1UpCarousel",
  "moduleColor": "Secondary",
  "items": Array.from({length: 10}, (_, index) => ({
    "title": `Card ${index + 1} Title`,
    "location": `Location ${index + 1}`,
    "description": `Lorem ipsum dolor sit amet consectetur. Vel fermentum phasellus semper eu nulla venenatis viverra variusisque.Lorem ipsum dolor sit amet consectetur.`,
    "rating": (8.5 + index / 10).toFixed(1),
    "ratingComment": index % 2 === 0 ? "Excellent" : "Good",
    "numberOfReviews": 120 + index * 5,
    "price": `£${250 + index * 10}`,
    "priceType": "per night",
    "date": `26 Apr - 27 Apr`,
    "imageAspectRatio": "CPDS_4x5",
    "cta": {
      "_key": null,
      "ctaText": "Book Now",
      "ctaUrl": null,
      "openUrlInNewTab": false
    },
    "image": {
      "asset": {
        "url": `https://via.placeholder.com/400x500?text=Card+${index + 1}`
      }
    }
  }))
};


export default {v3ShoppableOneUpCardCarouselModuleData, v3ShoppableOneUpCardCarouselModuleData2, v3ShoppableOneUpCardCarouselModuleData3};